<div class="max-w-6xl mx-auto px-4 flex flex-col gap-20">
  <div class="flex items-center justify-center md:justify-between pt-10">
    <h1 class="text-3xl md:text-5xl flex items-center">
      Exclua sua conta
    </h1>
  </div>

  <div class="w-full bg-gray-50 rounded-2xl p-4">
    <div class="columns-1 md:columns-4">
      <div>
        <img
          class="mx-auto pb-3"
          src="assets/imgs/tutorial/delete-1.png"
          alt=""
        />
        <p class="px-6 text-center">
          1 - Acesse o menu Perfil e vá em Meus dados
        </p>
      </div>
      <div>
        <img
          class="mx-auto pb-3"
          src="assets/imgs/tutorial/delete-2.png"
          alt=""
        />
        <p class="px-6 text-center">
          2 - <span class="text-error-500 font-medium">Excluir conta</span>
        </p>
      </div>
      <div>
        <img
          class="mx-auto pb-3"
          src="assets/imgs/tutorial/delete-3.png"
          alt=""
        />
        <p class="px-6 text-center">
          3 - Selecione o motivo (opcional) e toque em
          <span class="text-error-500 font-medium">Excluir</span>
        </p>
      </div>
      <div>
        <img
          class="mx-auto pb-3"
          src="assets/imgs/tutorial/delete-4.png"
          alt=""
        />
        <p class="px-6 text-center pb-4">
          4 - Seus dados serão permanentemente excluídos. Confirme em
          <span class="text-error-500 font-medium">Excluir</span>
        </p>
      </div>
    </div>
  </div>
</div>
